import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/services/app-service.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.scss']
})
export class EventsComponent implements OnInit {
  events: any = [];
  siteUrl = environment.siteUrl;
  constructor(private appService: AppService) {

  }

  ngOnInit() {
    this.appService.getEvents().subscribe((res: any) => {
      this.events = res;
    })
  }

}
